module.exports = __webpack_public_path__ + "img/HAPPYHAIR.6e687dc7.svg";